import { generatePath, Navigate } from "react-router";

import { PATHS } from "@/routes/paths";

import { MarketingCampaignTopPresenter } from "./presenter";
import { useCampaignTopQuery } from "../model/repository";

type Props = {
	hotelID: string;
};

export const MarketingCampaignTopContainer = ({ hotelID }: Props) => {
	const { data } = useCampaignTopQuery({ hotelID });

	if (!data) {
		return <Navigate to={generatePath(PATHS.HOTEL.TOP, { hotelID })} />;
	}

	return <MarketingCampaignTopPresenter hotelID={hotelID} data={data} />;
};

MarketingCampaignTopContainer.displayName = "MarketingCampaignTopContainer";
